import { Box, Typography, IconButton, Grid } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { colors } from "../../../../../../../ui/colors";
import { QueryState } from "../../../../../../../shared/components/query-states/GlobalQueryState";
import { useSpecialRequestsPagination } from "./hooks/useSpecialRequestsQuery";
import { useAppDispatch, useAppSelector } from "../../../../../../../../redux/hooks/redux";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";
import { SpecialRequestCard } from "./SpecialRequestsCard";
import { selectSpecialRequests } from "../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";

export const SpecialRequests = () => {
  const { isLoading, isError, items, page, totalPages, goNextPage, goPrevPage } = useSpecialRequestsPagination();

  const selectedRequests = useAppSelector(selectSpecialRequests);
  const { toggleSpecialRequest } = quoteCreateActions;
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <QueryState isLoading={isLoading} isError={!!isError} serviceName="Special Requests" />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        }}
      >
        <IconButton
          onClick={goPrevPage}
          disabled={page === 1}
          sx={{
            color: page === 1 ? colors.gray[300] : colors.orange.base,
            "&:hover": { backgroundColor: "rgba(255,120,0,0.08)" },
          }}
        >
          <ChevronLeft fontSize="large" />
        </IconButton>

        <Typography fontWeight={700} color={colors.gray[700]}>
          Page {page} / {totalPages}
        </Typography>

        <IconButton
          onClick={goNextPage}
          disabled={page === totalPages}
          sx={{
            color: page === totalPages ? colors.gray[300] : colors.orange.base,
            "&:hover": { backgroundColor: "rgba(255,120,0,0.08)" },
          }}
        >
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>
      <Grid container spacing={2} mt={1}>
        {items.map((req) => {
          const isSelected = selectedRequests.some((x) => x.uid === req.uid);

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={req.uid}>
              <SpecialRequestCard request={req} selected={isSelected} onSelect={() => dispatch(toggleSpecialRequest(req))} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
